import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MobileBottomNav from "./components/feature/MobileBottomNav";
import PWAInstallBanner from "./components/feature/PWAInstallBanner";

function FloatingDonateButton() {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === "/community") return null;
  return (
    <button
      onClick={() => navigate("/community")}
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 flex items-center gap-2 bg-rose-500 hover:bg-rose-600 text-white font-bold px-4 py-2.5 md:px-5 md:py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-sm"
      title="Donate to Infants & Community Help"
    >
      <i className="ri-heart-fill text-base animate-pulse"></i>
      <span className="hidden sm:inline">Donate 💝</span>
    </button>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <FloatingDonateButton />
        <MobileBottomNav />
        <PWAInstallBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
